import LocationsTable from './LocationsTable';
export default LocationsTable;